/* Fresca — benefits section: phone carousel synced with the icon pins around the jar. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (!root || root.dataset.ready) return;
    const track = root.querySelector('[data-benefits-track]');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('.fr-benefit'));
    const pins = Array.from(root.querySelectorAll('[data-benefit-pin]'));
    const dots = Array.from(root.querySelectorAll('[data-benefit-dot]'));
    if (!cards.length) return;
    root.dataset.ready = '1';

    const isCarousel = () => track.scrollWidth > track.clientWidth + 4 && getComputedStyle(track).overflowX !== 'visible';
    let active = -1;
    const setActive = (i) => {
      if (i === active) return;
      active = i;
      cards.forEach((c, j) => c.classList.toggle('is-active', j === i));
      pins.forEach((p, j) => { p.classList.toggle('is-active', j === i); p.setAttribute('aria-pressed', String(j === i)); });
      dots.forEach((d, j) => d.setAttribute('aria-current', String(j === i)));
    };
    const pad = () => parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    const nearest = () => {
      const x = track.scrollLeft + pad();
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) return cards.length - 1;
      let best = 0, dist = Infinity;
      cards.forEach((c, i) => { const d = Math.abs(c.offsetLeft - x); if (d < dist) { dist = d; best = i; } });
      return best;
    };
    const go = (i) => {
      const c = cards[i];
      if (!c) return;
      if (isCarousel()) track.scrollTo({ left: c.offsetLeft - pad(), behavior: reduced ? 'auto' : 'smooth' });
      setActive(i);
    };

    let raf = 0;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; if (isCarousel()) setActive(nearest()); });
    }, { passive: true });
    pins.forEach((p) => p.addEventListener('click', () => go(Number(p.dataset.benefitPin))));
    // Theme editor: selecting a block brings its card into view on phones
    root.addEventListener('shopify:block:select', (e) => { const i = cards.indexOf(e.target); if (i > -1) go(i); });
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.benefitDot))));

    const sync = () => { if (isCarousel()) setActive(nearest()); else { active = -1; cards.forEach((c) => c.classList.remove('is-active')); } };
    addEventListener('resize', sync, { passive: true });
    sync();
    if (isCarousel()) setActive(0);

    // Strip entrance on phones (cards themselves are never hidden by the per-card reveal there)
    if (!reduced && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        if (!en.isIntersecting) return;
        track.classList.add('is-in');
        io.disconnect();
      }, { threshold: 0.2 });
      io.observe(track);
    } else track.classList.add('is-in');
  };

  const boot = () => document.querySelectorAll('[data-benefits]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-benefits]')));
})();
